module.exports = __webpack_public_path__ + "img/Icon_HowToEarn.4ef4f995.svg";